import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { styled } from '@mui/material/styles';

import { CARD_H, CARD_W, IMG_H } from './utils';

export const StyledImageList = styled(ImageList)({
  height: `${CARD_H}px`,
  overflow: 'hidden',
});

export const StyledImageListItem = styled(ImageListItem)({
  backgroundColor: 'var(--white)',
  borderRadius: '1rem',
  height: `${CARD_H}px`,
  position: 'relative',
  width: `${CARD_W}px`,
});

export const StyledImg = styled('img')`
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  cursor: pointer;
`;

export const StyledIconButton = styled(IconButton)`
  cursor: pointer;
  margin: 4px 8px 0 0;
  min-width: 32px !important;
  position: absolute;
  right: 0;
  top: 0;
  width: 32px;
`;

export const StyledBox = styled(Box)({
  color: 'var(--black)',
  height: `${CARD_H - IMG_H}px`,
  padding: '0.5rem 1.25rem',
  textAlign: 'center',
  width: CARD_W + 'px',
});

export const StyledH3 = styled('h3')`
  margin-bottom: 0.5rem;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.25rem;
`;

export const StyledP = styled('p')`
  line-height: 1.25;
`;

export const OuterBox = styled(Box)`
  position: relative;
`;

export const CardBox = styled(Box)`
  &::-webkit-scrollbar {
    display: none;
  },
  msOverflowStyle: none;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
`;

const StyledNavButton = styled(IconButton)`
  border: 1px solid var(--gray3);
  border-radius: 0.5rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  padding: 0.5rem;
  position: absolute;
  top: 160px;
  z-index: 1;
`;

export const StyledButtonLeft = styled(StyledNavButton)`
  left: 0;
  right: auto;
`;

export const StyledButtonRight = styled(StyledNavButton)`
  right: 0;
`;
